import { Link, useLocation } from "react-router-dom";
import sidebarMenuData from "../sidebars/sidebar-data/sidebar-data";
import { useEffect, useState } from "react";

import './styles.scss';

const Breadcrumbs = ({ breadcrumbDetails }) => {
    const [breadcrumbValues, setBreadcrumbValues] = useState({});

    const location = useLocation()
    const createBreadcrumbs = (path) => {
        if (breadcrumbDetails) {
            setBreadcrumbValues(breadcrumbDetails)
        } else {
            sidebarMenuData?.map((data) => {
                data.subMenu?.map((subData) => {
                    if (subData?.link === path) {
                        const menuData = {
                            title: subData?.name,
                            parentMenu: {
                                name: data?.name,
                                link: data?.refLink[0],
                            },
                            subMenu: {
                                name: subData?.name,
                                link: subData?.link
                            },
                        }
                        setBreadcrumbValues(menuData)

                    }
                    return null
                })
                return null
            })
        }
    }

    useEffect(() => {
        createBreadcrumbs(location.pathname);
    }, [location.pathname, breadcrumbDetails])

    return (
        <div className="breadcrumb">
            <div className="breadcrumbs-contents">
                <div className="page-title">{breadcrumbValues?.title}</div>
                <div className="breadcrumb-items">
                    <Link to={breadcrumbValues?.parentMenu?.link} className="breadcrumb-items-link">{breadcrumbValues?.parentMenu?.name}</Link> {breadcrumbValues?.subMenu?.name && ">"}
                    <Link to={breadcrumbValues?.subMenu?.link} className="breadcrumb-items-link">{breadcrumbValues?.subMenu?.name}</Link>
                </div>
            </div>
        </div>
    )
}

export default Breadcrumbs;